module.exports = __webpack_public_path__ + "img/18a001-05.3d4b8511.jpg";